<template>
  <component v-if="isComponentContent" :is="activeContentComponent" />
  <div v-else v-html="activeContentResource"></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// todo: i18n versions of content in /ru, /ua directories

const contentComponents = {
  contacts: require('@/components/static/Contacts').default,
  tradein: require('@/components/static/Tradein').default,
  about: require('@/components/static/About').default,
  delivery: require('@/components/static/Delivery').default,
  franchise: require('@/components/static/Franchise').default,
  warranty: require('@/components/static/Warranty').default,
  privacypolicy: require('@/components/static/Privacy').default,
  legal: require('@/components/static/Legal').default,
  terms: require('@/components/static/Terms').default,
  sitemap: require('@/components/static/Sitemap').default,
}

export default {
  name: 'StaticPage',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.headline,
      }),
      meta: [
        this.isNoindex
          ? {
              name: 'robots',
              content: 'noindex, follow',
            }
          : {},
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.headline,
          }),
        },
      ],
    }
  },
  computed: {
    ...mapState(['headline']),
    isComponentContent() {
      return Object.keys(contentComponents).includes(this.slug)
    },
    activeContentComponent() {
      return contentComponents[this.slug]
    },
    activeContentResource() {
      return require(`@/assets/res/${this.slug}.htm`).default
    },
    isNoindex() {
      const allowedStaticPages = [
        'AboutPage',
        'RepairPage',
        'TradeInPage',
        'DeliveryPage',
        'WarrantyPage',
        'ContactsPage',
      ]
      return !allowedStaticPages.includes(this.$route.name)
    },
  },
  methods: {
    updateHeadline(slug) {
      let title = this.$te(`title.${slug}`)
        ? this.$t(`title.${slug}`)
        : this.$t(`mainMenu.${slug}`)
      this.setHeadline(title)
      this.$store.dispatch('setBreadcrumbs', [{ name: title }])
    },
    ...mapActions(['setHeadline']),
  },
  beforeMount() {
    this.updateHeadline(this.slug)
  },
  beforeUpdate() {
    this.updateHeadline(this.slug)
  },
  watch: {
    slug: function (newSlug) {
      this.updateHeadline(newSlug)
    },
    '$store.state.lang': function () {
      this.updateHeadline(this.slug)
    },
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>

<style></style>
